import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`10 年以上的專案開發經驗，歷經紮實的養成訓練，由程式設計師 → 系統設計師 → 系統分析師 → 技術經理。主要帶領專案開發部門承接金融領域之交易系統、商業智慧分析、情資整合分析平台及大數據分析平台架構設計與建置，目前任職於國泰金控數數發中心。`}</p>
    <p>{`GitHub: `}<a parentName="p" {...{
        "href": "https://github.com/ottoyen"
      }}>{`https://github.com/ottoyen`}</a></p>
    <p>{`相關演講經歷: Taiwan CDK Meetup`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      